document.addEventListener("turbolinks:load", function () {
    const input = document.getElementById("address-search");
    const results = document.getElementById("address-results");

    if (!input || !results) return;

    const items = results.querySelectorAll("li");

    // Filter list as you type
    input.addEventListener("input", function () {
      const query = input.value.toLowerCase().trim();
      let matchCount = 0;

      items.forEach((item) => {
        const address = item.dataset.address.toLowerCase();
        const matches = address.includes(query);
        item.style.display = matches ? "block" : "none";
        if (matches) matchCount++;
      });

      results.style.display = matchCount > 0 ? "block" : "none";
    });

    // Click to assign
    items.forEach((item) => {
      item.addEventListener("click", function () {
        const identifier = item.dataset.identifier;
        const updateUrl = item.dataset.updateUrl;

        fetch(updateUrl, {
          method: "PATCH",
          headers: {
            "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ unit_identifier: identifier })
        })
          .then((response) => {
            if (response.ok) {
              window.location.reload(); // Refresh to show assigned unit
            } else {
              return response.json().then(data => {
                throw new Error(data.error || "Unknown error");
              });
            }
          })
          .catch((error) => {
            alert(`Failed to assign unit: ${error.message}`);
          });
      });
    });

    // Hide dropdown on outside click
    document.addEventListener("click", function (e) {
      if (!results.contains(e.target) && e.target !== input) {
        results.style.display = "none";
      }
    });
  });
